import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFGoodDesign from '@/components/UI/svg/Delta2/Icon/EFGoodDesign';

const { EFPic } = createEFPic('/media/delta2/h5/');

export default function ProsThink({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');

    const thinkList = [
        {
            avatar: <EFPic name={['EFCNN.webp', 'EFCNN.png']} className="fullImgs" />,
            text: t('delta2.think_cnn'),
            style: { width: '1.87rem' },
        },
        {
            avatar: <EFPic name={['EFDIFA2022.webp', 'EFDIFA2022.png']} className="fullImgs" />,
            text: t('delta2.think_make_use'),
            style: { width: '0.5rem' },
        },
        {
            avatar: <EFPic name={['EFDigitalTrends.webp', 'EFDigitalTrends.png']} className="fullImgs" />,
            text: t('delta2.think_digital'),
            style: {},
        },
        {
            avatar: <EFPic name={['EFRandRoid.webp', 'EFRandRoid.png']} className="fullImgs" />,
            text: t('delta2.think_frAndroid'),
            style: {},
        },
    ];

    if (locale === 'au') {
        thinkList.push({
            avatar: <EFGoodDesign height="0.4rem" />,
            text: t('delta2.think_good_design'),
            style: {},
        });
    }

    return (
        <div className={`${css.prosThink} pros-think GtmModuleData-section`} data-section-id={css.prosThink} data-section-title={t('delta2.think_title_h5')}>
            <div className="title">{t('delta2.think_title_h5')}</div>
            <div className="think-wrapper">
                {thinkList.map((item: any, index) => (
                    <div className="think-panel" key={index}>
                        <div className="avatar" style={item.style}>
                            {item.avatar}
                        </div>
                        <div className="text">{item.text}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
